import React from 'react';
import { Icons } from '@generationtux/component-library';
import {
  JACKET_AND_PANTS,
  SHIRT,
  TIE,
  VEST_AND_CUMMERBUND,
  POCKET_SQUARE,
  LAPEL_PIN,
  CUFFLINKS,
  BELT_AND_SUSPENDERS,
  SHOES,
  SOCKS,
} from '../../data/categories';

const CategoryIcon = props => {
  const { category, color = 'grayDark' } = props;

  switch (category) {
    case JACKET_AND_PANTS:
      return <Icons.Jacket color={color} />;
    case SHIRT:
      return <Icons.Shirt color={color} />;
    case TIE:
      return <Icons.Tie color={color} />;
    case VEST_AND_CUMMERBUND:
      return <Icons.Vest color={color} />;
    case POCKET_SQUARE:
      return <Icons.PocketSquare color={color} />;
    case LAPEL_PIN:
      return <Icons.LapelPin color={color} />;
    case CUFFLINKS:
      return <Icons.Cufflinks color={color} />;
    case BELT_AND_SUSPENDERS:
      return <Icons.Belt color={color} />;
    case SHOES:
      return <Icons.Shoe color={color} />;
    case SOCKS:
      return <Icons.Socks color={color} />;
    default:
      return <></>;
  }
};

export default CategoryIcon;
